import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that strips HTML tags from a string value, converting
 * HTML-formatted test data (with <ul>, <li>, <span> etc.) into clean text.
 *
 * Usage: {{ value | stripHtml }}
 *
 * - Converts <li> items to bullet points ("* ")
 * - Extracts text from <span class="interactive-data"> tags
 * - Removes all other HTML tags
 * - Decodes common HTML entities
 */
@Pipe({
  name: 'stripHtml'
})
export class StripHtmlPipe implements PipeTransform {

  transform(value: any): string {
    return StripHtmlPipe.strip(value);
  }

  /**
   * Static method so it can be used both as a pipe and as a utility function
   * (e.g. in downloader/export logic without needing Angular DI).
   */
  static strip(value: any): string {
    if (value === null || value === undefined) return '';
    if (typeof value !== 'string') return String(value);
    if (!value.includes('<')) return value; // Quick check: no HTML tags

    let text = value
      // Convert <li> to bullet points
      .replace(/<li[^>]*>/gi, '- ')
      .replace(/<\/li>/gi, '\n')
      // Convert <br> to newline
      .replace(/<br\s*\/?>/gi, '\n');

    // Remove all remaining HTML tags (keeps inner text content)
    text = text.replace(/<[^>]*>/g, '');

    // Decode common HTML entities
    text = text
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&nbsp;/g, ' ');

    // Clean up whitespace: collapse multiple blank lines, trim each line
    text = text
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0)
      .join('\n')
      .trim();

    return text;
  }
}
